import ContentWrapper from "@/components/layouts/DashboardLayout/Content";
import routes from "@/routes";
import FilterComponent from "../SiteProductManagement/components/FilterComponent";
import { useTypedDispatch, useTypedSelector } from "@/app/store";
import { siteProductManagementSlide } from "../SiteProductManagement/siteProductManagement.slice";
import { useEffect, useState } from "react";
import styles from "./siteProductCUR.module.less";
import { Col, Form, Input, notification, QRCode, Row, Image, Spin, InputNumber, Flex, Typography } from "antd";
import clsx from "clsx";
import ButtonNotched from "@/components/ButtonNotched";
import { Link, useHistory, useLocation, useParams } from "react-router-dom";
import { BinType, MasterProductType, WarehouseType } from "@/utils/types";
import BoxIcon from "@/assets/icons/BoxIcon";
import WarehouseCodeDropdownList from "@/components/FilterSelectCustom/WarehouseCodeDropdownList";
import MasterProductCodeDropdownList from "@/components/FilterSelectCustom/MasterProductDropdownList";
import BinsCodeDropdownList from "@/components/FilterSelectCustom/BinsDropdownList";
import UnitDropdownList from "@/components/FilterSelectCustom/UnitDropdownList";
import message from "@/utils/message";
import { useCreateNewProductMutation, useEditProductMutation, useGetProductDetailQuery } from "@/rtk-query/productQueries";
import { getError } from "@/utils/helpers";
import { useGetUserInfoQuery } from "@/rtk-query/userQueries";
import C from "@/utils/constants";
import { CompanySelectType } from "../WarehouseManagement/warehouseManagement.slice";
import PositionDropdownList from "@/components/FilterSelectCustom/PositionDropdownList";

interface IProductCURModuleProps {
  type: "create" | "edit" | "view";
}
const validatorNumberSimple = (_: any, value: any) => {
  if (!value || (value && +value > 0)) {
    return Promise.resolve();
  }
  return Promise.reject();
};

export const handleCheckNumberKey = (evt: any) => {
  if ([".", "e", "-", "+", ","].includes(evt.key.toLowerCase())) {
    evt.preventDefault();
  }
};

const rowGutter: any = [0, 26];

function ProductCURModule({ type }: IProductCURModuleProps) {
  const params: any = useParams();
  const history = useHistory();
  const location = useLocation();
  const { companySelected, productIdSelected, wareHouseSelected, masterProductSelected } = useTypedSelector((store) => store.siteProductManagementSlide);

  const { currentData: userInfo } = useGetUserInfoQuery();

  const [binData, setBinData] = useState<BinType | null>(null);
  const [binSearch, setBinSearch] = useState("");
  const [searchWarehouse, setSearchWarehouse] = useState("");
  const [unit, setUnit] = useState<string>("");
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [position, setPosition] = useState<string>("");
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [positionSearch, setPositionSearch] = useState("");

  const [searchSiteProduct, setSearchSiteProduct] = useState("");
  const [form] = Form.useForm();

  const requiredValidate = (field: string, more?: { isNumber?: boolean }) => {
    return {
      required: true,
      validator: (_: any, value: string) => {
        if (more?.isNumber) {
          if (value === null || value === undefined) {
            return Promise.reject();
          }
          return String(value) && String(value)?.length && String(value)?.trim()?.length > 0 ? Promise.resolve() : Promise.reject();
        }
        return value && String(value) && String(value)?.length && String(value)?.trim()?.length > 0 ? Promise.resolve() : Promise.reject();
      },
      message: message.ERROR_NOT_BLANK(field),
    };
  };
  const dispatch = useTypedDispatch();

  const { onSelectCompany, onSelectProduct, onSelectWareHouse, onSelectMasterProduct } = siteProductManagementSlide.actions;
  const [createProduct, { isLoading: isLoadingCreate }] = useCreateNewProductMutation();
  const [updateProduct, { isLoading: isLoadingUpdate }] = useEditProductMutation();

  const { currentData: dataProduct, isLoading: isLoadingDataProduct } = useGetProductDetailQuery(params?.id, {
    skip: !params?.id,
    refetchOnMountOrArgChange: true,
  });

  const handleSelectProduct = (value: string | number | null) => {
    dispatch(onSelectProduct(value));
  };

  const handleSelectWarehouse = (value: WarehouseType | null) => {
    dispatch(onSelectWareHouse(value));
  };

  const handleSelectMasterProduct = (value: MasterProductType | null) => {
    dispatch(onSelectMasterProduct(value));
  };

  const handleSelectCompany = (value: CompanySelectType) => {
    dispatch(onSelectCompany(value));
    if (type === "create") {
      handleSelectWarehouse(null);
      setBinData(null);
      setBinSearch("");
      form.setFieldsValue({ warehouseId: "", binId: "" });
    }
  };

  const handleSubmit = async (values: any) => {
    if (!companySelected?.id) {
      return notification.error({
        message: message.ERROR_NOT_BLANK("Company"),
      });
    }
    const {
      productName = "",
      position = "",
      productCode = masterProductSelected?.manufactureItemNumber,
      manufactureItemNumber = masterProductSelected?.manufactureItemNumber,
      inventory = "",
      minimumQuantity = "",
      unit = "",
      binId = "",
      defaultReOrderQuantity = "",
    } = values;

    const masterProductId = productIdSelected;

    const body = {
      productName: String(productName),
      position: String(position),
      productCode: String(productCode),
      manufactureItemNumber: String(manufactureItemNumber),
      inventory: Number(inventory),
      minimumQuantity: Number(minimumQuantity),
      unit: String(unit),
      binId: String(binId),
      defaultReOrderQuantity: Number(defaultReOrderQuantity),
    };

    try {
      const res =
        type === "create"
          ? await createProduct({
              ...body,
              masterProductId: String(masterProductId),
            }).unwrap()
          : await updateProduct({ id: params?.id, body });
      if (res?.id || res?.data) {
        notification.success({
          message: message.SUCCESSFULLY,
        });
        handleSelectCompany(companySelected);
        handleSelectWarehouse(null);
        history.push(routes.siteProductList.path);
        return;
      }
      if (Array.isArray(res?.error?.data?.errors)) {
        res?.error?.data?.errors?.map(
          (erItem: string) =>
            erItem &&
            notification.error({
              message: erItem,
            })
        );
        return;
      }
      if (res?.errors) {
        notification.error({
          message: res?.message,
        });
      }
    } catch (error) {
      notification.error({
        key: "error_product_cur",
        message: getError(error),
      });
    }
  };

  const handleWheelInput = (e: any) => {
    e.target.blur();
    e.stopPropagation();
    setTimeout(() => {
      e.target.focus();
    }, 0);
  };

  useEffect(() => {
    if (type === "create") {
      setUnit(masterProductSelected?.unit || dataProduct?.unit || "");
      form.setFieldsValue({
        defaultReOrderQuantity: masterProductSelected?.minimumQuantity || dataProduct?.defaultReOrderQuantity,
        productCode: masterProductSelected?.manufactureItemNumber,
        productName: masterProductSelected?.productName,
      });
    }
  }, [masterProductSelected]);

  useEffect(() => {
    if (!dataProduct) return;
    const dataProductClone: any = dataProduct;
    handleSelectCompany(dataProductClone?.bin?.warehouse?.company);
    handleSelectProduct(dataProductClone?.masterProduct?.id || null);
    handleSelectMasterProduct(dataProductClone?.masterProduct);
    handleSelectWarehouse(dataProductClone?.bin?.warehouse);
    form.setFieldsValue({
      productName: dataProductClone?.productName,
      productCode: dataProductClone?.productCode,
      position: dataProductClone?.position,
      minimumQuantity: dataProductClone?.minimumQuantity,
      unit: dataProductClone?.unit,
      defaultReOrderQuantity: dataProductClone?.defaultReOrderQuantity,
      inventory: dataProductClone?.inventory,
      binId: dataProductClone?.bin.id,
      warehouseId: dataProductClone?.bin?.warehouse?.identityCode,
    });
    setBinData(dataProduct?.bin || null);
  }, [dataProduct, params]);

  useEffect(() => {
    handleSelectCompany(
      !companySelected
        ? null
        : {
            id: companySelected?.id || userInfo?.company?.id,
            companyName: companySelected?.companyName ?? userInfo?.company?.companyName,
            address: companySelected?.address || userInfo?.company?.address,
          }
    );
  }, [userInfo]);

  useEffect(() => {
    return () => {
      handleSelectProduct(null);
      handleSelectWarehouse(null);
    };
  }, []);

  const renderViewProduct = () => {
    const imageUrl = dataProduct?.productImageUrl || masterProductSelected?.images?.[0]?.imageUrl || C.IMAGE_DEFAULT;
    return (
      <>
        <div className={styles.box1}>
          <Row>
            <Col span={12}>
              {/* <p>Linkage to Stocktake’s product</p> */}

              <Row gutter={rowGutter}>
                <Col span={6}>Product name:</Col>
                <Col span={18}>{masterProductSelected?.productName}</Col>
                <Col span={6}>Item code:</Col>
                <Col span={18}>{masterProductSelected?.manufactureItemNumber}</Col>
                <Col span={6}>Unit:</Col>
                <Col span={18}>{masterProductSelected?.unit}</Col>
              </Row>
            </Col>
            <Col span={12}>
              <Flex justify="end" gap={20}>
                <div className={styles.wrapImage}>
                  <p style={{ color: "#234C66" }}>Master product image</p>
                  <Image src={imageUrl} width={160} alt="images" style={{ borderRadius: 5 }} />
                </div>
                {type !== "create" && (
                  <div className={styles.wrapImage}>
                    <p style={{ color: "#234C66" }}>QR code</p>
                    <QRCode
                      style={{ background: "#FFF" }}
                      value={JSON.stringify({
                        productId: dataProduct?.id,
                        companyId: companySelected?.id,
                      })}
                    />
                  </div>
                )}
                {type !== "create" && (
                  <div className={styles.wrapImage}>
                    <p style={{ color: "#234C66" }}>RFID code</p>
                    <QRCode
                      style={{ background: "#FFF" }}
                      value={JSON.stringify({
                        rfidCode: dataProduct?.rfidCode,
                        companyId: companySelected?.id,
                      })}
                    />
                  </div>
                )}
              </Flex>
            </Col>
          </Row>
        </div>
        <div className={clsx(styles.box1, styles.spaceBox)}>
          <Row>
            <Col span={12}>
              <Row gutter={rowGutter}>
                <Col span={6}>Company:</Col>
                <Col span={18}>{dataProduct?.bin.warehouse?.company.companyName}</Col>
                <Col span={6}>Address:</Col>
                <Col span={18}>{dataProduct?.bin.warehouse?.company.address}</Col>
              </Row>
            </Col>

            <Col span={12}>
              <Row gutter={rowGutter}>
                <Col span={6}>Warehouse code:</Col>
                <Col span={18}>{dataProduct?.bin.warehouse?.identityCode}</Col>
                <Col span={6}>Location:</Col>
                <Col span={18}>{dataProduct?.bin.warehouse?.location}</Col>
              </Row>
            </Col>
          </Row>
        </div>
        <div className={clsx(styles.box1, styles.spaceBox)}>
          <Row gutter={rowGutter}>
            <Col span={24}>
              <Row gutter={rowGutter}>
                <Col span={3}>RFID Code:</Col>
                <Col span={12}>{dataProduct?.rfidCode}</Col>
              </Row>
            </Col>

            <Col span={12}>
              <Row gutter={rowGutter}>
                <Col span={6}>Product name:</Col>
                <Col span={18}>{dataProduct?.productName}</Col>
                <Col span={6}>Product id:</Col>
                <Col span={18}>{dataProduct?.productCode}</Col>
              </Row>
            </Col>

            <Col span={12}>
              <Row gutter={rowGutter}>
                <Col span={6}>Current count:</Col>
                <Col span={18}>{dataProduct?.inventory}</Col>
                <Col span={6}>Max Par Level:</Col>
                <Col span={18}>{dataProduct?.minimumQuantity}</Col>
              </Row>
            </Col>

            <Col span={12}>
              <Row gutter={rowGutter}>
                <Col span={6}>Bin Code:</Col>
                <Col span={18}>{dataProduct?.bin.binCode}</Col>
                <Col span={6}>Position:</Col>
                <Col span={18}>{dataProduct?.position}</Col>
              </Row>
            </Col>

            <Col span={12}>
              <Row gutter={rowGutter}>
                <Col span={6}>Unit:</Col>
                <Col span={18}>{dataProduct?.unit}</Col>
                <Col span={6}>Reorder in Multiples of:</Col>
                <Col span={18}>{dataProduct?.defaultReOrderQuantity}</Col>
              </Row>
            </Col>
          </Row>
        </div>
      </>
    );
  };

  const renderCreateSiteProduct = () => {
    if (productIdSelected)
      return (
        <>
          <div className={styles.box1}>
            <Row>
              <Col span={18}>
                {/* <p className={styles.title}>Linkage to Stocktake’s product:</p> */}
                <Row className={clsx(styles.space, styles.flex)}>
                  <Col span={5} className={clsx(styles.contentRight, styles.leftMarginTop)}>
                    Product name:
                  </Col>
                  <Col span={17}>
                    <MasterProductCodeDropdownList
                      disabled={type === "edit"}
                      placeholder="Type here..."
                      style={{ width: 441, marginLeft: 13 }}
                      search={searchSiteProduct}
                      value={productIdSelected}
                      onChange={(productIdSelected: any, data?: MasterProductType) => {
                        handleSelectProduct(productIdSelected);
                        handleSelectMasterProduct(data || null);
                        setSearchSiteProduct("");
                      }}
                      dataSelected={masterProductSelected}
                      className={styles.masterProduct}
                      filter={{
                        ignoreDeleted: true,
                      }}
                    />
                  </Col>
                </Row>
                <Row className={styles.space}>
                  <Col span={5} className={styles.contentRight}>
                    Item code:
                  </Col>
                  <Col span={17}>{masterProductSelected?.manufactureItemNumber}</Col>
                </Row>
                <Row className={styles.space}>
                  <Col span={5} className={styles.contentRight}>
                    Unit:
                  </Col>
                  <Col span={17}>{masterProductSelected?.unit}</Col>
                </Row>
              </Col>
              <Col span={6}>
                <Row justify="space-evenly">
                  <div className={styles.wrapImage}>
                    <p>Master product image</p>
                    <br />
                    <Image
                      src={masterProductSelected?.images?.[0]?.imageUrl || ""}
                      width={146}
                      alt="images"
                      style={{ borderRadius: 5 }}
                      fallback={C.IMAGE_DEFAULT}
                    />
                  </div>

                  {dataProduct?.productImageUrl && (
                    <div className={styles.wrapImage}>
                      <p>Product image</p>
                      <br />
                      <Image src={dataProduct?.productImageUrl || ""} width={146} alt="images" style={{ borderRadius: 5 }} fallback={C.IMAGE_DEFAULT} />
                    </div>
                  )}
                </Row>
              </Col>
            </Row>
          </div>

          <div className={clsx(styles.box1, styles.spaceBox)} style={{ paddingBottom: 100 }}>
            <Row>
              <Col span={12}>
                <Row>
                  <Col span={5} className={styles.contentRight}>
                    Company:
                  </Col>
                  <Col span={17}>{companySelected?.companyName}</Col>
                </Row>
                <Row className={styles.space}>
                  <Col span={5} className={styles.contentRight}>
                    Address:
                  </Col>
                  <Col span={17}>{companySelected?.address}</Col>
                </Row>
              </Col>
              <Col span={12}>
                <Row>
                  <Col span={5} className={clsx(styles.contentRight, styles.leftMarginTop)}>
                    Warehouse code:
                  </Col>
                  <Col span={17}>
                    <Form.Item name="warehouseId" rules={[requiredValidate("Warehouse code")]}>
                      <WarehouseCodeDropdownList
                        placeholder={wareHouseSelected?.identityCode}
                        value={wareHouseSelected?.identityCode || null}
                        search={searchWarehouse}
                        onChange={() => {
                          setSearchWarehouse("");
                          form.setFieldsValue({ binId: "" });
                        }}
                        onChangeWareHouse={handleSelectWarehouse}
                        filter={{
                          companyId: companySelected?.id,
                          ignoreDeleted: true,
                        }}
                        className={styles.dropdown}
                        size="middle"
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row className={styles.space}>
                  <Col span={5} className={styles.contentRight}>
                    Location:
                  </Col>
                  <Col span={17}>{wareHouseSelected?.location}</Col>
                </Row>
              </Col>
            </Row>
          </div>

          <div className={clsx(styles.box1, styles.spaceBox)}>
            {type === "edit" && (
              <Row>
                <Col span={12}>
                  <Row className={clsx(styles.itemCenter)}>
                    <Col span={5} className={clsx(styles.contentRight)}>
                      RFID Code:
                    </Col>
                    <Col span={17}>{dataProduct?.rfidCode}</Col>
                  </Row>
                </Col>
              </Row>
            )}

            <Row className={styles.space}>
              <Col span={12}>
                <Row className={clsx(styles.itemCenter)}>
                  <Col span={5} className={clsx(styles.contentRight, styles.leftMarginTop)}>
                    Product name:
                  </Col>
                  <Col span={17}>
                    <Form.Item name="productName" rules={[requiredValidate("Product name")]}>
                      <Input defaultValue={masterProductSelected?.productName} size="middle" style={{ borderRadius: 0, height: 32 }} />
                    </Form.Item>
                  </Col>
                </Row>
                <Row className={clsx(styles.space, styles.flex)}>
                  <Col span={5} className={clsx(styles.contentRight, styles.leftMarginTop)}>
                    Product id:
                  </Col>
                  <Col span={17}>
                    <Form.Item name="productCode" rules={[requiredValidate("Product id")]}>
                      <Input defaultValue={masterProductSelected?.productCode} size="middle" style={{ borderRadius: 0, height: 32 }} disabled />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
              <Col span={12}>
                <Row>
                  <Col span={6} className={clsx(styles.contentRight, styles.leftMarginTop)}>
                    Current count:
                  </Col>
                  <Col span={18}>
                    <Form.Item
                      name="inventory"
                      rules={[
                        requiredValidate("inventory", { isNumber: true }),
                        {
                          required: true,
                          validator: validatorNumberSimple,
                          message: "Information is invalid!",
                        },
                      ]}
                    >
                      <InputNumber
                        onKeyDown={handleCheckNumberKey}
                        min={0}
                        size="middle"
                        name="inventory"
                        type="number"
                        onWheel={handleWheelInput}
                        style={{ borderRadius: 0, height: 32, width: "100%" }}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row className={clsx(styles.space, styles.flex)}>
                  <Col span={6} className={clsx(styles.contentRight, styles.leftMarginTop)}>
                    Max Par Level:
                  </Col>
                  <Col span={18}>
                    <Form.Item
                      name="minimumQuantity"
                      rules={[
                        requiredValidate("Max Par Level", {
                          isNumber: true,
                        }),
                        {
                          validator: validatorNumberSimple,
                          message: "Information is invalid!",
                        },
                      ]}
                    >
                      <InputNumber
                        onKeyDown={handleCheckNumberKey}
                        min={0}
                        size="middle"
                        type="number"
                        style={{ borderRadius: 0, height: 32, width: "100%" }}
                        onWheel={handleWheelInput}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
              {/* // info product */}
              <Col span={12}>
                <Row className={clsx(styles.space, styles.itemCenter)}>
                  <Col span={5} className={clsx(styles.contentRight, styles.leftMarginTop)}>
                    Bin Code:
                  </Col>
                  <Col span={9}>
                    <Form.Item name="binId" rules={[requiredValidate("Bin Code")]} className={styles.wFull} style={{ minWidth: 162 }}>
                      <BinsCodeDropdownList
                        className={clsx(styles.dropdown, styles.wFull)}
                        onChange={(e) => {
                          setBinData(e || null);
                          setBinSearch("");
                          form.setFieldsValue({ binId: e?.id || "" });
                        }}
                        value={binData?.id}
                        search={binSearch}
                        filter={{
                          warehouseId: wareHouseSelected?.id,
                          ignoreDeleted: true,
                        }}
                        skip={!wareHouseSelected?.id}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row className={clsx(styles.space, styles.flex)}>
                  <Col span={5} className={clsx(styles.contentRight, styles.leftMarginTop)}>
                    Position:
                  </Col>
                  <Col span={9}>
                    <Form.Item name="position" rules={[requiredValidate("Position")]} className={styles.wFull} style={{ minWidth: 162 }}>
                      <PositionDropdownList
                        className={clsx(styles.dropdown, styles.wFull)}
                        onChangePos={(e) => {
                          setPosition(e || "");
                          setPositionSearch("");
                          form.setFieldsValue({ position: e || "" });
                        }}
                        value={binData?.id}
                        search={binSearch}
                        filter={{
                          warehouseId: wareHouseSelected?.id,
                          ignoreDeleted: true,
                        }}
                        skip={!wareHouseSelected?.id}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>

              <Col span={12}>
                <Row className={clsx(styles.space)}>
                  <Col span={6} className={clsx(styles.contentRight, styles.leftMarginTop)}>
                    Unit:
                  </Col>
                  <Col span={7}>
                    <Form.Item name="unit" rules={[requiredValidate("Unit")]}>
                      <UnitDropdownList
                        className={styles.dropdown}
                        value={unit}
                        onChange={(value) => {
                          setUnit(value || "");
                          form.setFieldsValue({ unit: value || "" });
                        }}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row className={clsx(styles.space, styles.flex)}>
                  <Col span={6} className={clsx(styles.contentRight, styles.leftMarginTop)}>
                    Reorder in Multiples of:
                  </Col>
                  <Col span={18}>
                    <Form.Item
                      name="defaultReOrderQuantity"
                      rules={[
                        requiredValidate("Reorder in Multiples of", {
                          isNumber: true,
                        }),
                      ]}
                      className={styles.wFull}
                    >
                      <InputNumber
                        onKeyDown={handleCheckNumberKey}
                        min={masterProductSelected?.minimumQuantity}
                        size="middle"
                        type="number"
                        step={20}
                        style={{
                          borderRadius: 0,
                          height: 32,
                          width: "100%",
                        }}
                        className={styles.wFull}
                        onWheel={handleWheelInput}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </>
      );
    return (
      <div className={styles.box1}>
        <Row>
          <Col span={18}>
            <p className={styles.title}>Linkage to Stocktake’s product:</p>
            <Row className={clsx(styles.space, styles.itemCenter, styles.flex)}>
              <Col span={5} className={styles.contentRight}>
                Product name:
              </Col>
              <Col span={17}>
                <MasterProductCodeDropdownList
                  disabled={type === "edit"}
                  placeholder="Type here..."
                  style={{ width: 441 }}
                  search={searchSiteProduct}
                  value={productIdSelected}
                  onChange={(e: any, data?: MasterProductType | null) => {
                    handleSelectProduct(e);
                    setSearchSiteProduct("");
                    handleSelectMasterProduct(data || null);
                  }}
                  className={styles.masterProduct}
                  filter={{
                    ignoreDeleted: true,
                  }}
                  dataSelected={masterProductSelected}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    );
  };

  const titlePage = () => {
    let title = "";
    switch (type) {
      case "edit":
        title = routes.editSiteProduct.title;
        break;
      case "view":
        title = routes.viewSiteProduct.title;
        break;
      default:
        title = routes.createSiteProduct.title;
        break;
    }

    return title;
  };
  return (
    <ContentWrapper
      dataBreadCrumb={[
        {
          title: routes.siteProductList.title,
          icon: <BoxIcon />,
          url: routes.siteProductList.path,
        },
        {
          title: titlePage(),
          url: location.pathname,
          style: {
            fontWeight: 800,
          },
        },
      ]}
      renderFilter={<FilterComponent type={type} onSelectCompany={handleSelectCompany} onSelectWareHouse={handleSelectWarehouse} />}
    >
      {isLoadingDataProduct ? (
        <Row
          justify="center"
          style={{
            padding: 36,
          }}
        >
          <Spin tip="Loading" size="large" />
        </Row>
      ) : (
        <Form name="control-hooks" labelCol={{ span: 4, sm: 6 }} wrapperCol={{ span: 24 }} onFinish={handleSubmit} autoComplete="off" form={form}>
          <div className={styles.siteProductView}>
            <Typography.Title level={5} style={{ marginBottom: 20 }}>
              Linkage to Stocktake’s product
            </Typography.Title>

            {type === "view" ? renderViewProduct() : renderCreateSiteProduct()}

            {productIdSelected && (
              <div className={clsx(styles.spaceBox, styles.boxBottom, styles.wrapButtons)} style={{ width: "100%" }}>
                <Link to={routes.siteProductList.path}>
                  <ButtonNotched onClick={() => handleSelectCompany(null)} type="dark">
                    {type === "create" ? "Cancel" : "Back"}
                  </ButtonNotched>
                </Link>
                {type === "view" && (
                  <Link to={routes.editSiteProduct.path.replace(":id", dataProduct?.id || "")}>
                    <ButtonNotched type="primary">Edit</ButtonNotched>
                  </Link>
                )}
                {(type === "create" || type === "edit") && (
                  <div>
                    {isLoadingCreate || isLoadingUpdate ? (
                      <Spin>
                        <button
                          type="submit"
                          style={{
                            background: "transparent",
                            border: "none",
                          }}
                        >
                          <ButtonNotched type="primary">Save</ButtonNotched>
                        </button>
                      </Spin>
                    ) : (
                      <button
                        type="submit"
                        style={{
                          background: "transparent",
                          border: "none",
                        }}
                      >
                        <ButtonNotched type="primary">Save</ButtonNotched>
                      </button>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
        </Form>
      )}
    </ContentWrapper>
  );
}

export default ProductCURModule;
